import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { formatMonths } from '@/helpers/date';
import { RangeInput } from '../RangeInput';
import s from './index.module.scss';

export const InvestmentTerm = ({
  min,
  max,
  value,
  step,
  description,
  onRangeChange,
}) => {
  const { t } = useTranslation('calculator');

  const currentLabel = formatMonths(value, t);
  const rangeLabelStart = formatMonths(min, t);
  const rangeLabelEnd = formatMonths(max, t);

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={classnames(s.label, 'f-body-accent')}>
          {t('inv_terms.investment_term')}
        </div>
        <div className={classnames(s.input, 'f-body-regular')}>
          {currentLabel.short_label}
        </div>
      </div>
      <RangeInput
        value={[value]}
        step={step}
        min={min}
        max={max}
        onChange={onRangeChange}
        className={s.range}
      />
      <div className={s.range_footer}>
        <div className="f-small-regular">{rangeLabelStart.full_label}</div>
        <div className="f-small-regular">{rangeLabelEnd.full_label}</div>
      </div>
      {description && (
        <div className={classnames(s.desc, 'f-small-regular')}>{description}</div>
      )}
    </div>
  );
};
